<template>
    <div>
        <a class="text-poly-green">
            <span>Boardroom</span>
            <i class="fa fa-info" style="color: rgb(255, 255, 255);"></i>
        </a>
    </div>
</template>

<script>

export default {

    name: 'VaAnswerInfoButton',

    methods: {
        applyAction(params) {
            this.$emit('applyAction', params);
        }
    }

}
</script>
